module.exports = __webpack_public_path__ + "img/d7639f70ce30444e8420c0d30f9a777e-640.c238770d.jpg";